import { useState, useEffect } from 'react';
import * as TablerIcons from '@tabler/icons-react';

const componentMap = {
  './pages/Dashboard': () => import('../pages/Dashboard'),
  './pages/Versements': () => import('../pages/Versements'),
  './pages/versements/VersementsHistorique': () =>
    import('../pages/versements/VersementsHistorique'),
  './pages/gestion/ServicesGestion': () => import('../pages/gestion/ServicesGestion'),
  './pages/gestion/FondsGestion': () => import('../pages/gestion/FondsGestion'),
  './pages/gestion/TypesContenuGestion': () => import('../pages/gestion/TypesContenuGestion'),
  './pages/consultations/ConsultationDemande': () =>
    import('../pages/consultations/ConsultationDemande'),
  './pages/consultations/ConsultationHistorique': () =>
    import('../pages/consultations/ConsultationHistorique'),
  './pages/consultations/ConsultationDemandesEnAttente': () =>
    import('../pages/consultations/ConsultationDemandesEnAttente'),
  './pages/consultations/ConsultationRetour': () =>
    import('../pages/consultations/ConsultationRetour'),
  './pages/consultations/ConsultationRelances': () =>
    import('../pages/consultations/ConsultationRelances'),
  './pages/Destructions': () => import('../pages/Destructions'),
  './pages/destructions/DestructionEditionDemandes': () =>
    import('../pages/destructions/DestructionEditionDemandes'),
  './pages/destructions/DestructionRetourDemande': () =>
    import('../pages/destructions/DestructionRetourDemande'),
  './pages/destructions/DestructionEtat': () => import('../pages/destructions/DestructionEtat'),
  './pages/destructions/DestructionHistorique': () =>
    import('../pages/destructions/DestructionHistorique'),
  './pages/recherches/Recherches': () => import('../pages/recherches/Recherches'),
  './pages/EtatsReporting': () => import('../pages/recherches/Recherches'),
  './pages/emplacements/EmplacementsVisuGraphique': () =>
    import('../pages/emplacements/EmplacementsVisuGraphique'),
  './pages/emplacements/EmplacementsGestion': () =>
    import('../pages/emplacements/EmplacementsGestion'),
  './pages/Statistiques': () => import('../pages/Statistiques'),
  './pages/statistiques/TauxOccupation': () => import('../pages/statistiques/TauxOccupation'),
  './pages/statistiques/BoitesParService': () => import('../pages/statistiques/BoitesParService'),
  './pages/ProfilUtilisateur': () => import('../pages/ProfilUtilisateur'),
  './pages/parametres/ImportXml': () => import('../pages/parametres/ImportXml'),
  './pages/parametres/ParametresReglages': () => import('../pages/parametres/ParametresReglages'),
  './pages/parametres/ParametresImprimante': () =>
    import('../pages/parametres/ParametresImprimante'),
  './pages/parametres/ParametresUtilisateurs': () =>
    import('../pages/parametres/ParametresUtilisateurs'),
  './pages/admin/ServerStatus': () => import('../pages/admin/ServerStatus'),
  './pages/admin/LoginEvents': () => import('../pages/admin/LoginEvents'),
};

export function useDynamicImport(componentPath, iconName) {
  const [component, setComponent] = useState(null);
  const [icon, setIcon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setComponent(null);
    setIcon(null);
    setError(null);

    if (!componentPath) {
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        setLoading(true);
        if (iconName && TablerIcons[iconName]) {
          setIcon(() => TablerIcons[iconName]);
        }

        const importFn = componentMap[componentPath];
        if (!importFn) {
          throw new Error(`Composant non trouvé: ${componentPath}`);
        }

        const mod = await importFn();
        setComponent(() => mod.default);
      } catch (err) {
        console.error('[useDynamicImport]', err);
        setError(err.message);
        setComponent(null);
        setIcon(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [componentPath, iconName]);

  return { component, icon, loading, error };
}
